export const GET_ALL_PRODUCTS = 'GET_ALL_PRODUCTS'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const GET_SINGLE_PROJECT = 'GET_SINGLE_PROJECT'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
